export default __webpack_public_path__ + "static/media/10.09bb7e2f.png";